export { default } from "./dist/botoxs.common"
export * from "./dist/botoxs.common"
export * from "./dist/botoxs.browser"



//////////////////
// WEBPACK FOOTER
// ./node_modules/botoxs2/index.js
// module id = tjKH
// module chunks = 66